// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal[data-v-9867e316]{padding:30px 35px;text-align:center}.modal .btn[data-v-9867e316]{white-space:unset}.modal .title[data-v-9867e316]{font-size:1.125rem;font-weight:700;margin:20px 0 0}.modal p[data-v-9867e316]{font-weight:300}.modal a[data-v-9867e316],.modal p[data-v-9867e316]{display:inline-block;font-size:.875rem;margin:20px 0 0}.modal .actions[data-v-9867e316]{margin:30px 0 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
